import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import axios from "axios";
import { constants, RANDOM_STRING_LENGTH } from "../assets/constants/constants";
import { BASE_URL, endPoints, VITE_STATIC_CONTENT_URL } from "../services/urls";
import { generateRandomString } from "../lib/utils";

const cacheBuster = generateRandomString(RANDOM_STRING_LENGTH);

i18n
  .use(initReactI18next)
  .use({
    type: "backend",
    init: function () { },
    read: async function (language: any, _: any, callback: any) {

      try {
        // set dutch languge HS-1658
        const selectLanguage = BASE_URL?.indexOf('perf') !== -1  ? localStorage.getItem("locale") :constants.dutchLocale //|| constants.dutchLocale;
        // generates the random string - appending the random string is cache busting
        const response = await axios.get(
          `${VITE_STATIC_CONTENT_URL}/${endPoints.STATIC_VARIABLES}/${selectLanguage}.json?v=${cacheBuster}`
        );
        const fallbackData = await import(
          `./locales/${selectLanguage?.split("-")[0]}/translations.json`
        );
        // Merge the fetched translations with the fallback translations
        const mergedData: any = {};
        Object.keys(fallbackData).forEach((key) => {
          mergedData[key] = { ...fallbackData[key], ...response?.data[key]};
        });
        // Finally, call the callback with the merged translations
        mergedData.cookies.cookiesContent= mergedData.cookies.cookiesContent.replaceAll(/(?<!&nbsp;)(&nbsp;)(?!&nbsp;)/g," ")
        mergedData.privacyAndPolicy.privacyPolicyContent= mergedData.privacyAndPolicy.privacyPolicyContent.replaceAll(/(?<!&nbsp;)(&nbsp;)(?!&nbsp;)/g," ")
        mergedData.termsAndCondition.termsConditionContent= mergedData.termsAndCondition.termsConditionContent.replaceAll(/(?<!&nbsp;)(&nbsp;)(?!&nbsp;)/g," ")
        callback(null, mergedData);
      } catch (error) {
        console.error("Error fetching translations:", error);
        try {
          const fallbackData = await import(`./locales/${language}/translations.json`);
          // Merge the fetched translations with the fallback translations
          callback(null, fallbackData);
        } catch (e) {
          console.error("Error loading local fallback data:", e);
          callback(e, null);
        }
      }
    },
  })
  .init({
    fallbackLng:  constants.dutchCode,// localStorage.getItem("i18nextLng") ?? constants.dutchCode,
    lng:  constants.dutchCode,//localStorage.getItem("i18nextLng") ?? constants.dutchCode,
    debug: true,
    returnObjects: true,
    supportedLngs: [constants.dutchCode, constants.englishCode],
    interpolation: {
      escapeValue: false,
    },
    defaultNS: "translations",
    initImmediate: false,
    missingKeyHandler: function (lng, _: any, key, __: any) {
      console.warn(`Missing key: "${key}" for language: ${lng}`);
    },
    missingInterpolationHandler: function (value) {
      if (value === undefined || value === "") {
        return null;
      }
      return value;
    },
  });

export default i18n;
